export default "__VITE_ASSET__DYTRZ2fd__"